import { render, staticRenderFns } from "./LTVTable.vue?vue&type=template&id=73b778fa&scoped=true&"
import script from "./LTVTable.vue?vue&type=script&lang=ts&"
export * from "./LTVTable.vue?vue&type=script&lang=ts&"
import style0 from "./LTVTable.vue?vue&type=style&index=0&id=73b778fa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73b778fa",
  null
  
)

export default component.exports